export enum ChangeEmailModalFlow {
  ValidateCurrentPassword = 'ValidateCurrentPassword',
  ResetPassword = 'ResetPassword',
  NewEmail = 'NewEmail',
  VerifyCurrentEmailOTP = 'VerifyCurrentEmailOTP',
  VerifyOTP = 'VerifyOTP',
  EmailChangedSuccessfully = 'EmailChangedSuccessfully',
}
